/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Key_InvalidInputs */



/**
* | output |
* | --- |
* | "The endpoint rejected the API key. Check the key. A redirect drops it too, so enter the final URL." |
*
* @param {Private_Models_Hint_Key_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_key_invalid = /** @type {((inputs?: Private_Models_Hint_Key_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Key_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Endpunkt hat den API-Schlüssel abgelehnt. Prüfen Sie den Schlüssel. Auch eine Weiterleitung verwirft ihn, geben Sie also die endgültige URL ein.")
	return /** @type {LocalizedString} */ ("The endpoint rejected the API key. Check the key. A redirect drops it too, so enter the final URL.")
});